import { useAutoProgress } from "./AutoProgressButton";
import { ProgressListItem } from "./ProgressListItem";

export const AutoProgressListItem = ({
    onClick: propsOnClick,
    children,
    ...rest
}) => {
    const { inProgress, onClick } = useAutoProgress(propsOnClick);
    return (
        <ProgressListItem
            {...rest}
            disabled={inProgress}
            inProgress={inProgress}
            onClick={onClick}
        >
            {children}
        </ProgressListItem>
    );
};
